import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { BellRing } from "lucide-react";

export const FollowUpBanner = ({ refreshKey }) => {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/event-follow-ups").then((r) => setS(r.data)).catch(() => {}); }, [refreshKey]);
  if (!s?.overdue?.length) return null;
  return (
    <div className="mb-5 flex flex-col gap-2 rounded-xl border border-red-200 bg-red-50 px-4 py-3 sm:flex-row sm:items-center sm:justify-between" data-testid="follow-up-banner">
      <div className="flex items-start gap-3">
        <BellRing className="mt-0.5 h-5 w-5 shrink-0 text-red-600" />
        <div>
          <div className="text-sm font-bold text-red-800" data-testid="follow-up-banner-count">{s.overdue_pending} Visitor{s.overdue_pending === 1 ? " Still Needs" : "s Still Need"} Follow-Up</div>
          <div className="text-xs text-red-700">{s.overdue.map((o) => `${o.name} (${o.pending})`).join(" · ")}</div>
        </div>
      </div>
      <div className="flex flex-wrap gap-2">
        {s.overdue.map((o) => (
          <Link key={o.id} to={`/events?event=${o.id}&filter=not_contacted`} className="rounded-md bg-red-600 px-3 py-1.5 text-xs font-semibold text-white hover:bg-red-700" data-testid={`follow-up-banner-open-${o.id}`}>
            Follow Up {o.name}
          </Link>
        ))}
      </div>
    </div>
  );
};
